export const GRAPHQL_VARIABLES = {
  record: {
    name: 'another name',
    description: 'updated description'
  }
};

export const QUERY = `
mutation companiesUpdateOne ($record: UpdateOneRestrictedInput!) {
    companiesUpdateOne (record: $record) {
        recordId
        record {
            name
            categoryCode
            address {
                address1
                address2
                address3
                state
                city
                zip
                country
                _id
            }
            email
            bookipiCompany
            phoneNumber
            website
            websiteType
            businessType
            businessName
            description
            ABN
            ACN
            ein
            industry
            bankDetails {
                bankName
                accountName
                accountNo
                routingNumber
                ownershipType
                accountType
            }
            individuals {
                documentType
                licenceNumber
                jurisdiction
                additionalDocumentType
                title
                birth
                firstName
                lastName
                ownership
                address {
                    address1
                    address2
                    address3
                    state
                    city
                    zip
                    country
                    _id
                }
                email
                phone
                _id
                country
                additionalDocumentType
                roles
                enableDLBackSide
                driverLicence { url contentType }
                passport { url contentType }
                utilityBill { url contentType }
                ssn
            }
            monthlyCardValue
            monthlyTransactions
            annualTurnover
            serviceDeliveryDays
            annualCreditTurnover
            averageDeliveryTime
            averageSalesAmount
            hasSignature
            verified
            currency
            payProvider
            _id
            updatedAt
            createdAt
            additionalPrimaryDocument{ url contentType}
            bankStatement{ url contentType}
            payProvider
            fatzebra{ onboardingStep onboardStartDate onboardNextNotification }
            globalPay{ onboardingStep onboardStartDate onboardNextNotification sessionId }
            discountedCcRate{ rate fee amexRate amexFee}
            transactions{
                  _id
                  provider
                  type
                  amount
                  status
                  note
                  createdAt
                  ccFee
                }
        }
    }
}
`;
